/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import { getHeaderWithTooltip } from './HeaderTooltip';
import { Plus, X } from 'lucide-react';

const MultiAddInputV1 = ({
  label,
  placeholder,
  parsedLabel,

  rawValue,
  setRawValue,

  parsedValuesArray,
  setParsedValues,

  handleRemoveParsedValue,
  handleAddValue,
}) => {
  return (
    <label htmlFor='label'>
      {getHeaderWithTooltip(`${label}`)}

      <div className='tw-relative'>
        <input
          value={rawValue}
          onChange={(e) => setRawValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // prevent form submit
              handleAddValue(); // your custom function
            }
          }}
          className='tw-w-full tw-px-6 tw-py-6 tw-rounded-lg tw-border-solid tw-border-[1px] tw-border-grey-300 tw-text-base tw-text-grey-900'
          placeholder={placeholder}
          type='text'
          autoFocus
          autoComplete='off'
        />
        <button
          type='button'
          className='tw-absolute tw-right-1 tw-top-1 tw-aspect-square tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-border-none tw-m-2 tw-text-base-green hover:tw-opacity-80 hover:tw-bg-green-300/40 tw-cursor-pointer tw-transition-all tw-duration-200 tw-ease-in-out'
          onClick={handleAddValue}
        >
          <Plus className='tw-transition-transform hover:tw-scale-110' />
        </button>
      </div>

      {/* Parsed Values UI */}
      {parsedValuesArray?.length > 0 && (
        <div className='tw-mt-4 tw-flex tw-items-center tw-gap-2'>
          <div className='tw-font-medium tw-text-grey-800 tw-whitespace-nowrap'>
            {parsedLabel}
          </div>
          <div className='tw-text-sm tw-text-grey-700 tw-flex tw-gap-2 tw-flex-wrap'>
            {parsedValuesArray.map((id, index) => (
              <span
                key={`${index}_${id}`}
                className='tw-bg-base-green tw-text-white tw-font-medium tw-px-2 tw-py-1 tw-rounded-lg tw-gap-2 tw-flex tw-items-center tw-justify-between tw-flex-nowrap'
              >
                {id}
                <span
                  className='tw-aspect-square tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-w-6 tw-h-6 tw-cursor-pointer tw-transition-all tw-ease-in-out tw-duration-200'
                  onClick={handleRemoveParsedValue.bind(
                    null,
                    setParsedValues,
                    id,
                  )}
                >
                  <X size={16} />
                </span>
              </span>
            ))}
          </div>
          <span
            className='tw-font-medium tw-text-grey-600 tw-px-3 tw-py-1.5 tw-rounded-lg tw-mr-2 tw-inline-block tw-cursor-pointer tw-whitespace-nowrap tw-transition-all tw-duration-200 tw-ease-in-out hover:tw-bg-grey-200'
            onClick={() => {
              setParsedValues([]);
              setRawValue('');
            }}
          >
            Clear All
          </span>
        </div>
      )}
    </label>
  );
};

export default MultiAddInputV1;
